import { render, staticRenderFns } from "./SheetCardAction.vue?vue&type=template&id=12ea9b50&scoped=true&"
import script from "./SheetCardAction.vue?vue&type=script&lang=js&"
export * from "./SheetCardAction.vue?vue&type=script&lang=js&"
import style0 from "./SheetCardAction.vue?vue&type=style&index=0&id=12ea9b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ea9b50",
  null
  
)

export default component.exports